import config from "@/config"
import http from "@/utils/request"

export default {
    list: {
		url: `${config.API_URL}/deviceCommandRecord/`,
		name: "查询设备下发指令记录",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},

}
